import React from 'react';
import { styled } from '@mui/material';
import { RTitle } from './RTitle';
import { RCountBubble } from './RCountBubble';

interface RSectionHeaderProps {
    title: string;
    count?: number;
}

export function RSectionHeader({ title, count }: RSectionHeaderProps) {
    return (
        <Header>
            <RTitle size="h2">{title}</RTitle>
            {count !== undefined && <RCountBubble count={count} />}
        </Header>
    );
}

const Header = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 14,
});
